/*
 * Created by mac on 2/28/23
 */

const Yatzy = function (level, options) {
    GameBase.call(this, level, options);

    this.level = level;
    this.options = options;

    const save = this.savedGame || {};
    const content = this.levelContent || {};

    this.slots = [];
    const savedSlots = cleverapps.override(content.slots || {}, save.slots || {});
    for (let i = 0; i < 13; i++) {
        this.slots.push(new Slot(i, savedSlots[i]));
    }

    this.dices = [];
    const savedDices = cleverapps.override(content.dices || {}, save.dices || {});
    for (let j = 0; j < 5; j++) {
        this.dices.push(new Dice(j, savedDices[j]));
    }

    this.score.setPoints(save.score || content.score || 0);
    this.opponentScore = save.opponentScore ? new Score(save.opponentScore) : undefined;

    this.bonus = save.bonus || content.bonus || 0;
    this.bonusReceived = save.bonusReceived || content.bonusReceived || false;

    const goal = this.goal = this.level.content.goal ? new Goal(this.level.content.goal, save.goal) : undefined;
    if (goal) {
        goal.setAmount(this.score.points);
    }

    this.rolls = save.rolls !== undefined ? save.rolls : Yatzy.MAX_ROLLS;
    this.rolled = false;
    this.rollCount = save.rollCount || 0;
    this.playCount = save.playCount || 0;

    this.counter.registerStage(1, this.afterRoll.bind(this));
    this.counter.registerStage(3, this.checkExclamations.bind(this));
    this.counter.registerStage(11, this.hideDicesStage.bind(this));
    this.counter.registerStage(12, this.calculatePlayScore.bind(this));
    this.counter.registerStage(13, this.checkWin.bind(this));
    this.counter.registerStage(14, this.nextRound.bind(this));
    this.counter.registerStage(100, this.autoRoll.bind(this));
    this.counter.registerStage(150, this.enableRollButton.bind(this));

    // GameBase no longer tracks the secondary mission: the letter tournament marks 6s while it runs
    const letterMission = cleverapps.missionManager.findByType(Mission.TYPE_LETTER);
    if (letterMission && letterMission.isRunning()) {
        this.letterMission = letterMission;
    }
};

Game = Yatzy;

Yatzy.prototype = Object.create(GameBase.prototype);
Yatzy.prototype.constructor = Yatzy;

Yatzy.prototype.setBasicReward = function () {
    this.basicReward = 5;
};

Yatzy.prototype.addBasicReward = function () {
    [0, 101, 151, 201, 251].forEach((threshold) => {
        if (this.score.points >= threshold) {
            this.addSoftReward(this.basicReward);
        }
    });
};

Yatzy.prototype.getInfo = function () {
    const info = GameBase.prototype.getInfo.call(this);

    info.slots = this.slots.map((slot) => slot.getInfo());
    info.dices = this.dices.map((dice) => dice.getInfo());
    info.score = this.score.getPoints();
    info.opponentScore = this.opponentScore ? this.opponentScore.getPoints() : undefined;
    if (this.goal) {
        info.goal = this.goal.getInfo();
    }
    info.rolls = this.rolls;
    info.bonus = this.bonus;

    if (this.rollCount) {
        info.rollCount = this.rollCount;
    }

    if (this.playCount) {
        info.playCount = this.playCount;
    }

    return info;
};

Yatzy.prototype.autoRoll = function () {
    if (this.outcome !== GameBase.OUTCOME_UNKNOWN || BasicsTutorial.isAvailable()) {
        return;
    }

    if (this.fullRolls()) {
        this.roll(true);
    }
};

Yatzy.prototype.afterRoll = function () {
    if (!this.rolled) {
        return;
    }

    const yatzyPlayed = this.slots[Slot.YATZY].used;

    this.slots.filter((slot) => {
        if (this.hintSlots) {
            return this.hintSlots.includes(slot.id);
        }
        return true;
    }).forEach((slot) => {
        if (!slot.used) {
            slot.setScore(slot.calcScore(yatzyPlayed));
        }
    });
};

Yatzy.prototype.checkExclamations = function () {
    if (!this.rolled) {
        return;
    }

    this.rolled = false;

    let message;

    this.slots.forEach((slot) => {
        if (!slot.used && slot.score === Slot.YATZY_SCORE) {
            message = "YATZY";
        }
    });

    if (message) {
        cleverapps.exclamation.show(message);

        cleverapps.audio.playSound(bundles.game.urls.yatzy);

        this.counter.setTimeout(() => {
            const exclamationView = cleverapps.Scenes.GetSceneComponent(GameSceneComponent).exclamationView;
            exclamationView.animation.removeFromParent();
            delete exclamationView.animation;
        }, 1500);
    } else {
        this.highlightCombo();
    }
};

Yatzy.prototype.highlightCombo = function () {
    let slotToHighlight;
    for (let slotId = Slot.YATZY; slotId >= Slot.ONES; slotId--) {
        const slot = this.slots[slotId];
        if (!slot.used && slot.score) {
            if (this.hintSlots && !this.hintSlots.includes(slotId)) {
                continue;
            }
            // upper-section slots get highlighted only when the tutorial points at them
            if (slotId <= Slot.SIXES && !this.hintSlots) {
                continue;
            }
            slotToHighlight = slotId;
            break;
        }
    }

    if (slotToHighlight !== undefined) {
        const highlightDices = this.getSlotComboDices(slotToHighlight);
        if (highlightDices && highlightDices.length) {
            if (!this.allDicesChosen(highlightDices)) {
                const after = highlightDices.length + 1;
                const cb = cleverapps.wait(after, () => {
                    this.counter.dec();
                });
                this.counter.inc();
                this.trigger("highlightDices", highlightDices, cb);
                this.slots[slotToHighlight].highlight(cb);
            }
        }
    }
};

Yatzy.prototype.allDicesChosen = function (dices) {
    return dices.reduce((allChosen, diceId) => allChosen && this.dices[diceId].chosen, true);
};

Yatzy.prototype.getSlotComboDices = function (slotId) {
    const diceCount = this.getDiceCount();
    let mainScore;
    for (mainScore = 1; mainScore <= 6; mainScore++) {
        if (diceCount[mainScore] > 2) {
            break;
        }
    }

    if (slotId <= Slot.SIXES) {
        return this.dices.filter((dice) => dice.score === slotId + 1).map((dice) => dice.id);
    }

    switch (slotId) {
        case Slot.YATZY:
        case Slot.LARGE_STRAIGHT:
        case Slot.FULL_HOUSE:
            return [0, 1, 2, 3, 4];
        case Slot.THREE_OF_A_KIND:
        case Slot.FOUR_OF_A_KIND:
            return this.dices.filter((dice) => dice.score === mainScore).map((dice) => dice.id);
        case Slot.SMALL_STRAIGHT: {
            const sequence = this.getSequences().find((seq) => seq.length > 3).slice(-4);
            return this.dices.filter((dice) => {
                const index = sequence.indexOf(dice.score);
                if (index !== -1) {
                    sequence.splice(index, 1);
                    return true;
                }
                return false;
            }).map((dice) => dice.id);
        }
    }
};

Yatzy.prototype.getSequences = function () {
    return this.dices.map((dice) => dice.score).sort().reduce((sequences, score) => {
        if (score !== undefined) {
            const lastSequence = sequences.slice(-1)[0];
            if (lastSequence.indexOf(score) === -1) {
                if (!lastSequence.length || lastSequence.slice(-1)[0] + 1 === score) {
                    lastSequence.push(score);
                } else {
                    sequences.push([score]);
                }
            }
        }
        return sequences;
    }, [[]]);
};

Yatzy.prototype.resetDices = function () {
    this.dices.forEach((dice) => {
        dice.setChosen(false);
    });
};

Yatzy.prototype.fullRolls = function () {
    return this.rolls === Yatzy.MAX_ROLLS;
};

Yatzy.prototype.noRollsLeft = function () {
    return this.rolls === 0;
};

Yatzy.prototype.play = function (slot) {
    slot.select();

    // praise a scored row, a zero is a miss; a Yatzy is worth two ordinary moves
    if (cleverapps.likePraise) {
        if (slot.score > 0) {
            cleverapps.likePraise.notify(cleverapps.aims.getTarget(`slot${slot.id}`), (slot.score >= Slot.YATZY_SCORE ? 2 : 1) * LikePraise.MOVE_VALUE);
        } else {
            cleverapps.likePraise.missed();
        }
    }

    this.resetDices();
    this.playedSlot = slot;
    this.trigger("enableRollButton", false);

    this.collectMarks();

    this.counter.setTimeout(() => {
        this.counter.inc();
        this.trigger("play", slot, () => {
            this.counter.dec();
        });
    }, 100);

    cleverapps.tutorial.trigger("slot");

    this.setRolls(Yatzy.MAX_ROLLS);

    this.playCount++;

    cleverapps.audio.playSound(bundles.game.urls.click_roll);
};

Yatzy.prototype.hideDicesStage = function () {
    if (!this.playedSlot) {
        return;
    }

    this.dices.forEach((dice) => {
        dice.hide();
    });
};

Yatzy.prototype.calculatePlayScore = function () {
    if (!this.playedSlot) {
        return;
    }
    const playedSlot = this.playedSlot;
    delete this.playedSlot;

    const addScore = playedSlot.score;
    if (addScore) {
        this.score.addPoints(addScore);
    }
    if (this.goal) {
        this.goal.setAmount(this.score.points);
    }

    if (this.opponentScore) {
        const opponentScore = this.setOpponentResult();
        this.opponentScore.addPoints(opponentScore);
    }

    this.calcFirstColumnScore();

    playedSlot.confirm();
    this.nextRoundReady = true;
};

Yatzy.prototype.nextRound = function () {
    if (!this.nextRoundReady) {
        return;
    }

    if (!cleverapps.tutorial.isActive()) {
        this.trigger("showDicesDescription");
    }

    this.nextRoundReady = false;
};

Yatzy.prototype.checkWin = function () {
    if (this.calculateRemaining() === 0) {
        if (this.goal) {
            if (this.goal.isCompleted()) {
                this.win();
            } else {
                this.lose();
            }
        } else {
            this.win();
        }
    }
};

Yatzy.prototype.calculateRemaining = function () {
    return this.slots.filter((slot) => !slot.used).length;
};

Yatzy.prototype.removeRoll = function (auto) {
    if (!auto) {
        this.rollCount++;
    }
    this.setRolls(this.rolls - 1);
};

Yatzy.prototype.addRoll = function () {
    this.setRolls(this.rolls + 1);
};

Yatzy.prototype.getProlongationOffer = function () {
    if (this.needProlongationOffer()) {
        this.prolongationOffer = this.prolongation.getOffer(Prolongation.REWARDS.MOVES);
    } else {
        this.prolongationOffer = undefined;
    }
    return this.prolongationOffer;
};

Yatzy.prototype.needProlongationOffer = function () {
    if (!this.noRollsLeft()) {
        return false;
    }

    // the prolongation tutorial hands out the free roll through this offer, any other tutorial gets none
    if (cleverapps.tutorial.isActive()) {
        return cleverapps.tutorial.getActive().name === ProlongationTutorial.NAME;
    }

    return cleverapps.forces.isShown(Forces.FREE_PROLONGATION_FORCE) || ProlongationTutorial.isAvailable();
};

Yatzy.prototype.setRolls = function (rolls) {
    this.rolls = rolls;
    this.trigger("changeRolls");
};

Yatzy.prototype.setBonus = function (bonus) {
    if (!this.bonusReceived && this.bonus !== bonus) {
        this.bonus = bonus;
        this.trigger("updateBonus");

        if (this.bonus >= Yatzy.BONUS_GOAL) {
            this.bonusReceived = true;
            this.counter.inc();
            this.trigger("receiveBonus", () => {
                this.score.addPoints(Yatzy.BONUS_REWARD, true);
                this.counter.dec();
            });
        }
    }
};

Yatzy.prototype.calcFirstColumnScore = function () {
    let score = 0;
    for (let i = 0; i < 6; i++) {
        if (this.slots[i].used || this.slots[i].selected) {
            score += this.slots[i].score;
        }
    }
    this.setBonus(score);
};

Yatzy.prototype.setGameMode = function (mode) {
    if (mode === Yatzy.SOLO && this.opponentScore !== undefined) {
        delete this.opponentScore;
    }
    if (mode === Yatzy.VERSUS && this.opponentScore === undefined) {
        this.opponentScore = new Score(this.calculateOpponentScore());
    }

    cleverapps.Scenes.GetSceneComponent(YatzySceneComponent).changeGameMode();
};

Yatzy.prototype.setOpponentResult = function () {
    const availableSlots = this.slots.filter((slot) => !slot.opponentUsed);
    let slot = Math.floor(Math.random() * availableSlots.length);
    slot = availableSlots[slot].id;
    let score = 0;

    if ([Slot.ONES, Slot.TWOS, Slot.THREES, Slot.FOURS, Slot.FIVES, Slot.SIXES].indexOf(slot) !== -1) {
        score = Math.floor(Math.random() * 5) * (slot + 1);
    }

    switch (slot) {
        case Slot.THREE_OF_A_KIND:
            score = Math.floor(Math.random() * 26 + 5);
            break;
        case Slot.FOUR_OF_A_KIND:
            score = Math.floor(Math.random() * 26 + 5);
            break;
        case Slot.SMALL_STRAIGHT:
            score = Math.floor(Math.random() > 0.2 ? 1 : 0) * 30;
            break;
        case Slot.LARGE_STRAIGHT:
            score = Math.floor(Math.random() > 0.3 ? 1 : 0) * 40;
            break;
        case Slot.FULL_HOUSE:
            score = Math.floor(Math.random() > 0.25 ? 1 : 0) * 25;
            break;
        case Slot.YATZY:
            score = Math.floor(Math.random() > 0.9 ? 1 : 0) * 50;
            break;
        case Slot.CHANCE:
            score = Math.floor(Math.random() * 26 + 5);
            break;
    }

    this.slots[slot].setOpponentScore(score);

    return score;
};

Yatzy.prototype.calculateOpponentScore = function () {
    let score = 0;
    this.slots.forEach((slot) => {
        score += slot.opponentScore || 0;
    });
    return score;
};

Yatzy.prototype.showScreen = function (f, silent) {
    this.once("showFieldEnd", f);
    this.trigger("showField", silent);
    this.trigger("showDices", silent);
    this.trigger("showResults", silent);
    this.trigger("showRollButton", silent);

    cleverapps.audio.playSound(bundles.game.urls.window_game);

    if (!this.levelWithTutorial()) {
        this.trigger("showDicesDescription");
    }
};

Yatzy.prototype.onRollButtonClick = function () {
    if (this.counter.isActive()) {
        return;
    }

    if (this.rolls) {
        this.roll();
        return;
    }

    if (this.prolongationOffer) {
        this.prolongation.acceptOffer(this.prolongationOffer);
    }
};

Yatzy.prototype.roll = function (auto) {
    if (this.noRollsLeft()) {
        return;
    }

    const toRoll = this.dices.filter((dice) => !dice.chosen);

    if (toRoll.length === 0) {
        return;
    }

    this.rolled = true;
    this.trigger("enableRollButton", false);

    toRoll.forEach(function (dice) {
        const suggested = this.suggestedRoll && this.suggestedRoll[dice.id];
        this.counter.inc();
        dice.roll(suggested, () => {
            this.counter.setTimeout(() => { }, 200);
            this.counter.dec();
        });
    }, this);

    this.suggestedRoll = undefined;
    this.removeRoll(auto);

    cleverapps.tutorial.trigger("roll");

    cleverapps.audio.playSound(auto ? bundles.game.urls.rotation : bundles.game.urls.roll);
};

Yatzy.prototype.setSuggestedRoll = function (rolls) {
    this.suggestedRoll = rolls;
};

Yatzy.prototype.onAcceptProlongationOffer = function (offer) {
    if (offer === this.prolongationOffer) {
        this.prolongationOffer = undefined;
        this.setRolls(this.rolls + offer.moves);
        this.roll();
    }
};

Yatzy.prototype.getProlongationMoves = function () {
    return 1;
};

Yatzy.prototype.collectMarks = function () {
    const dicesWithMarks = this.dices.filter((dice) => dice.mark);
    dicesWithMarks.forEach((dice, index) => {
        this.counter.setTimeout(dice.collectMark.bind(dice), 200 * index);
    });
};

Yatzy.prototype.hasBegan = function () {
    return Boolean(this.rollCount) || Boolean(this.playCount);
};

Yatzy.prototype.getDiceCount = function () {
    return this.dices.reduce((diceCount, dice) => {
        if (dice.score) {
            diceCount[dice.score] = diceCount[dice.score] !== undefined ? diceCount[dice.score] + 1 : 1;
        }
        return diceCount;
    }, []);
};

Yatzy.prototype.enableRollButton = function () {
    let enable = true;
    if ((this.playedSlot || this.rolled)) {
        enable = false;
    }

    this.trigger("enableRollButton", enable);
};

Yatzy.BONUS_REWARD = 35;
Yatzy.BONUS_GOAL = 63;

Yatzy.MAX_ROLLS = 3;

Yatzy.SOLO = 1;
Yatzy.VERSUS = 2;
